// import { initializeApp } from "firebase/app";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import axios from "axios";
// // Firebase Configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyAsw-lRp42gkpy4Mz0zFF9QJ8CEqBQOLss",
//   authDomain: "unsmemberportal-65d5a.firebaseapp.com",
//   projectId: "unsmemberportal-65d5a",
//   storageBucket: "unsmemberportal-65d5a.appspot.com",
//   messagingSenderId: "664068251932",
//   appId: "1:664068251932:web:fa167348210999e675dad9",
// };

// const app = initializeApp(firebaseConfig);
// const messaging = getMessaging(app);

// // ✅ Register Service Worker (Make sure the path is correct)
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js") // MUST be in `public/`
//     .then((registration) => {
//       console.log("Service Worker Registered:", registration);
//     })
//     .catch((error) => {
//       console.error("Service Worker Registration Failed:", error);
//     });
// }

// // Function to request push notification permission
// export const requestNotificationPermission = async () => {
//   const getUserData = JSON.parse(localStorage.getItem("user"));
//   // console.log("getUserData", getUserData);
//   const userId = getUserData?.id;
//   // console.log("userId", userId);
//   try {
//     const token = await getToken(messaging, {
//       vapidKey:
//         "BE7ncsHpP6eupWtGW6n3vnEZVx7KxGghm2VT9spaRKqnPzw59ibpnMjgvZXk35HieXB54gEenq4ote7LCRXdidU",
//     });

//     if (token) {
//       console.log("FCM Token:", token);
//       // console.log("Push Notification Token:", token);
//       await axios.post(
//         `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/save-token`,
//         {
//           userId, // Assuming the logged-in user's ID is 1 for now, you should use the actual user ID
//           token,
//         }
//       );
//       return token;
//     } else {
//       console.error("No token received. Check permission settings.");
//     }
//   } catch (error) {
//     console.error("Error getting FCM token:", error);
//   }
// };

// // Listen for foreground notifications
// onMessage(messaging, (payload) => {
//   console.log("Received foreground notification:", payload);
//   alert(payload.notification.body);
// });

// // // ✅ Handle Foreground Notifications (Show Alert)
// // onMessage(messaging, (payload) => {
// //   console.log("🔥 Foreground notification received:", payload);

// //   // Show an alert popup
// //   alert(payload.notification?.body || "You have a new notification!");

// //   // Optional: Display a browser notification
// //   if (Notification.permission === "granted") {
// //     new Notification(payload.notification?.title || "New Message", {
// //       body: payload.notification?.body || "Check your messages.",
// //       icon: "/firebase-logo.png",
// //     });
// //   }
// // });
// export default messaging;
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axios from "axios";
// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyAsw-lRp42gkpy4Mz0zFF9QJ8CEqBQOLss",
  authDomain: "unsmemberportal-65d5a.firebaseapp.com",
  projectId: "unsmemberportal-65d5a",
  storageBucket: "unsmemberportal-65d5a.appspot.com",
  messagingSenderId: "664068251932",
  appId: "1:664068251932:web:fa167348210999e675dad9",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// ✅ Save Notification to LocalStorage
const saveNotification = (notification) => {
  const existingNotifications =
    JSON.parse(localStorage.getItem("notifications")) || [];
  const updatedNotifications = [notification, ...existingNotifications];
  localStorage.setItem("notifications", JSON.stringify(updatedNotifications));

  // ✅ Increase Unread Count
  let unreadCount = parseInt(localStorage.getItem("unreadCount") || "0", 10);
  unreadCount += 1;
  localStorage.setItem("unreadCount", unreadCount.toString());
};

// ✅ Listen for Foreground Notifications
onMessage(messaging, (payload) => {
  console.log("Received Notification:", payload);

  const notification = {
    title: payload.notification?.title || "New Notification",
    body: payload.notification?.body || "You have a new message!",
    timestamp: new Date().toISOString(),
  };

  saveNotification(notification);
});

// Function to request push notification permission
export const requestNotificationPermission = async () => {
  const getUserData = JSON.parse(localStorage.getItem("user"));
  const userId = getUserData?.id;

  try {
    const token = await getToken(messaging, {
      vapidKey:
        "BE7ncsHpP6eupWtGW6n3vnEZVx7KxGghm2VT9spaRKqnPzw59ibpnMjgvZXk35HieXB54gEenq4ote7LCRXdidU",
    });

    if (token) {
      console.log("FCM Token:", token);

      await axios.post(
        `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/save-token`,
        {
          userId, // Assuming the logged-in user's ID is 1 for now, you should use the actual user ID
          token,
        }
      );

      return token;
    } else {
      console.error("No token received. Check permission settings.");
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
  }
};

export default messaging;
